export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  coverImage: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '最新视频',
    slug: 'videos',
    description: '萌白酱最新发布的视频作品合集，包含B站、抖音等多平台内容',
    icon: 'ri-vidicon-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20virtual%20YouTuber%20streaming%20setup%20with%20pink%20warm%20lighting%2C%20gaming%20monitor%20displaying%20colorful%20content%2C%20kawaii%20decorations%2C%20soft%20pastel%20background%2C%20dreamy%20atmosphere%2C%20high%20quality%20photography%2C%20clean%20composition&width=800&height=500&seq=mengbai-cat-videos&orientation=landscape',
    articleCount: 24,
  },
  {
    id: 'cat-2',
    name: 'Cosplay写真',
    slug: 'cosplay',
    description: '萌白酱精心打造的cosplay写真作品集，展现不同角色的魅力',
    icon: 'ri-camera-lens-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20cosplay%20photography%20studio%20setup%20with%20soft%20pink%20backdrop%2C%20professional%20lighting%20equipment%2C%20costume%20racks%20with%20colorful%20outfits%2C%20warm%20dreamy%20atmosphere%2C%20creative%20artistic%20space%2C%20clean%20minimalist%20decor%2C%20high%20quality%20commercial%20photography&width=800&height=500&seq=mengbai-cat-cosplay&orientation=landscape',
    articleCount: 36,
  },
  {
    id: 'cat-3',
    name: '动态资讯',
    slug: 'news',
    description: '萌白酱的最新活动动态、直播预告、粉丝互动等资讯信息',
    icon: 'ri-news-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Social%20media%20content%20creation%20workspace%20with%20colorful%20notes%20and%20sticky%20memos%20on%20wall%2C%20warm%20pink%20toned%20lighting%2C%20creative%20bulletin%20board%20with%20cute%20illustrations%2C%20cozy%20atmosphere%2C%20modern%20minimalist%20desk%2C%20professional%20photography&width=800&height=500&seq=mengbai-cat-news&orientation=landscape',
    articleCount: 18,
  },
  {
    id: 'cat-4',
    name: '周边产品',
    slug: 'merch',
    description: '萌白酱官方正版周边商品，包含手办、挂画、服饰等多种类型',
    icon: 'ri-shopping-bag-3-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20merchandise%20display%20shelf%20with%20anime%20figurines%20and%20accessories%2C%20warm%20pink%20pastel%20background%2C%20soft%20ambient%20lighting%2C%20organized%20retail%20display%2C%20clean%20modern%20aesthetic%2C%20product%20photography%20style%2C%20dreamy%20atmosphere&width=800&height=500&seq=mengbai-cat-merch&orientation=landscape',
    articleCount: 15,
  },
  {
    id: 'cat-5',
    name: '粉丝社区',
    slug: 'community',
    description: '萌白酱粉丝交流社区，包含活动回顾、粉丝作品展示、互动话题等内容',
    icon: 'ri-group-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20fan%20community%20gathering%20space%20with%20soft%20pink%20decorations%2C%20cute%20illustrations%20on%20walls%2C%20comfortable%20seating%20area%2C%20creative%20workshop%20atmosphere%2C%20warm%20lighting%2C%20friendly%20vibe%2C%20modern%20cafe%20style%20interior%2C%20professional%20photography&width=800&height=500&seq=mengbai-cat-community&orientation=landscape',
    articleCount: 22,
  },
];

export const getAllCategories = (): Category[] => categories;

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug);
};